import React, { useState } from 'react';
import styled from 'styled-components';
import { Button } from 'reactstrap';
import { DraggableData, DraggableEvent } from 'react-draggable';
import { useRightMenuTabContext } from '../../contexts/RightMenuTabContext';
import NewTabIcon from '../icons/NewTabIcon';
import DraggableModal from '../basics/DraggableModal';
import { captureEvent } from '../../utils/analytics';

const NewTabButton = styled(Button)`
  font-size: 8px; // Avoid extra space above svg
  ${({ $hovered }) => !$hovered && 'visibility: hidden;'}
`;

const PopOutTab = ({ children }: { children: React.ReactNode }) => {
  const { popOutTabOpen, setPopOutTabOpen } = useRightMenuTabContext();
  const [hovered, setHovered] = useState(false);
  return popOutTabOpen ? null : (
    <div
      // Extra padding on right side to engage hover button
      className="d-flex align-items-center"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {children}
      <NewTabButton
        className="px-2 py-0"
        color="link"
        onClick={() => {
          setPopOutTabOpen(true);
          setHovered(false);
          captureEvent('pop-out-tab-opened');
        }}
        $hovered={hovered}
      >
        <NewTabIcon />
      </NewTabButton>
    </div>
  );
};

export default PopOutTab;

export const PopOutTabContainer = ({
  title,
  children,
}: {
  title: string;
  children: React.ReactNode;
}) => {
  const {
    popOutTabOpen,
    popOutTabPosition,
    resetPopOutTab,
    setPopOutTabPosition,
  } = useRightMenuTabContext();
  const updatePosition = (_e: DraggableEvent, data: DraggableData) =>
    setPopOutTabPosition({ x: data.x, y: data.y });
  return popOutTabOpen ? (
    <DraggableModal
      defaultPosition={popOutTabPosition}
      isOpen={popOutTabOpen}
      onStop={updatePosition}
      setIsOpen={resetPopOutTab}
      startPosition={{ right: 0, top: 0 }} // Override DraggableModal default
      title={title}
    >
      {children}
    </DraggableModal>
  ) : (
    children
  );
};
